module.exports = __webpack_public_path__ + "img/shark.aa761084.jpg";